<template>
  <div>
    <span :class="premiumClasses ?? 'fw-bold fs-30'">
      &dollar;{{ formattedInteger }}
    </span>
    <sup v-if="superscriptClasses" :class="superscriptClasses">
      .{{ formattedFraction }}
    </sup>
    <span v-else :class="premiumClasses ?? 'fw-bold fs-30'">
      .{{ formattedFraction }}
    </span>
    <span :class="subtextClasses ?? 'fs-12'">{{ subtext }}</span>
  </div>
</template>

<script>
export default {
  name: "CurrencyPresentation",
  props: {
    premiumAmount: { type: [Number, String], required: true },
    subtext:        { type: String,  default: "" },
    superscriptClasses: String,
    premiumClasses:     String,
    subtextClasses:     String,
  },
  computed: {
    normalized() {
      const n = parseFloat(this.premiumAmount);
      return isNaN(n) ? "0.00" : n.toFixed(2);
    },
    formattedInteger() {
      return this.normalized.split(".")[0];
    },
    formattedFraction() {
      return this.normalized.split(".")[1];
    },
  },
};
</script>
